window.getValid_fieldLength = function (formId) {
    return $("#" + formId).find("input.required:visible.ui-state-valid,textarea.required:visible.ui-state-valid,select.required:visible.ui-state-valid").length;
};

var updateMaxlengthInfo = function() {
    var $that = $(this);
    setTimeout(function() {
        if($that.hasClass('wcs-delivery-info-textarea')) {
            $that.val($that.val().replace(/[<>]/g,''));
        }
        var maxlength = $that.attr('maxlength'),
            current_length = $that.val().length;
        var newLines = $that.val().match(/(\r\n|\n|\r)/g);
        var total_length = newLines ? current_length + newLines.length : current_length;

        if (total_length > maxlength) {
            var str = $that.val().replace(/(\r\n|\n|\r)/g, "\r\n");
            str = str.substring(0, maxlength);
            $that.val(str);
            $that.change();
            return;
        }
        var remaining = maxlength === current_length ? 0 : maxlength - (total_length);
        $that.parent().find('.wcs-delivery-hint-text .setCount-txtarea').html(remaining);
    }, 1);
};

var remove_dropdown_validation = function(formObj) {
    var $dropdownText = formObj.find('.wcs-dropdown-text');
    $dropdownText.parents('.wcs-custom-dropdown-container').removeClass('ui-state-error');
    $dropdownText.parents('.wcs-row').find('.wcs-error-message').removeClass('wcs-show');
};

/* Overall select box validation functionalities */
var dropdown_validation = function(formObj) {
    formObj.find('.wcs-dropdown-text:visible').each(function() {
        var $this = $(this);
        if ($this.hasClass('wcs-dropdown-validation')) {
            show_dropDown_error_message($this);
        } else {
            hide_dropDown_error_message($this);
        }
    });
};

var get_error_number = function(count) {
    var numbersHash = {};
    var error = $("#lblErrorMsg").val();
    var errors = $("#lblErrorsMsg").val();
    numbersHash[1] = ["1 "+error];
    numbersHash[2] = ["2 "+errors];
    numbersHash[3] = ["3 "+errors];
    numbersHash[4] = ["4 "+errors];
    numbersHash[5] = ["5 "+errors];
    numbersHash[6] = ["6 "+errors];
    numbersHash[7] = ["7 "+errors];
    numbersHash[8] = ["8 "+errors];
    numbersHash[9] = ["9 "+errors];
    numbersHash[10] = ["10 "+errors];
    numbersHash[11] = ["11 "+errors];
    numbersHash[12] = ["12 "+errors];
    numbersHash[13] = ["13 "+errors];
    numbersHash[14] = ["14 "+errors];
    numbersHash[15] = ["15 "+errors];
    numbersHash[16] = ["16 "+errors];
    numbersHash[17] = ["17 "+errors];
    numbersHash[18] = ["18 "+errors];
    numbersHash[19] = ["19 "+errors];
    numbersHash[20] = ["20 "+errors];
    return numbersHash[count];
};

/* Strip-out HTML Tags In Textarea*/
function stripOutHTMLTag(elem) {
    var $elem = $(elem);
    var str = $elem.val();
    var reg = /(<([^>]+)>)/ig;
    if (reg.test(str)) {
        str = str.replace(reg, '');
        $elem.val(str);
    }
    return str;
}
 /*RB-868 Patterns Change*/
window.zipcode_pattern = function(zipcode_id, country) {
    var pattern,
        countryCode = !!country? country.toLowerCase() : country;
    switch (countryCode) {
        case 'br':
            pattern = '(\\d{5}[-]?\\d{3}?)';
            break;
        case 'us':
            pattern = '(\\d{5}([\\-]\\d{4})?)';
            break;
        case 'ca':
            pattern = '[A-Za-z](\\s?)[0-9](\\s?)[A-Za-z](\\s?)[0-9](\\s?)[A-Za-z](\\s?)[0-9](\\s?)';
            break;
        case 'cn':
            pattern = '(\\d{6}?)';
            break;
        case 'pl':
            pattern = '(\\d{2}([\\-]\\d{3}))';
            break;
        case 'dk':
            pattern = '(\\d{3,4})';
            break;
        case 'ch':
            pattern = '^(?!(7563|8238|6911)).*(\\d{4})';
            break;
        case 'tr':
            pattern = '^(?!99).*(\\d{5})';
            break;
        case 'no':
            pattern = '(\\d{4})';
            break;
        case 'se':
            pattern = '^\\d{5}|(\\d{3}[\\s|\\d{1}]\\d{2})';
            break;
        case 'at':
            pattern = '(\\d{4})';
            break;
        case 'be':
            pattern = '(\\d{4})';
            break;
        case 'it':
            pattern = '^(?!(23030)).*(\\d{5})';
            break;
        case 'fr':
            pattern = '^(?!(97[1-8])).*^(?!(98[6-8])).*(\\d{5})';
            break;
        case 'de':
            pattern = '^(?!(78266|27498)).*(^(\\d{4,5})$)';
            break;
        case 'es':
            pattern = '^(?!52).*^(?!51).*^(?!35).*^(?!38).*(\\d{5})';
            break;
        case 'gb':
            pattern='^(?!BF).*^(?!GY).*^(?!JE).*^(?!FO).*^(?!bf).*^(?!gy).*^(?!je).*^(?!fo).*([A-Za-z0-9 ]{5,7})';
            break;
        case 'nl':
            pattern='([0-9][0-9][0-9][0-9][\\s]?[A-Za-z][A-Za-z])';
            break;
        case 'ie':
            pattern='(^([a-zA-Z0-9\\s]){7,8}$)';
            break;
        case 'pt':
            pattern='[0-9]{4}-[0-9]{3}';
            break;
        case 'fi':
            pattern='^(?!22).*(\\d{5})';
            break;
        case 'mx':
            pattern='^(|[0-9_-]{5})$';
            break;
        case 'au':
            pattern = '(\\d{4})';
            break;
        case 'gr':
            zipcode_id.attr('maxlength', '6');
            pattern = '^\\d{3}\\s{0,1}\\d{2}$';
            break;
        case 'lu':
            zipcode_id.attr('maxlength', '4');
            pattern = '^\\d{4}$';
            break;
        case 'si':
            zipcode_id.attr('maxlength', '7');
            pattern = '^([Ss][Ii][- ]{0,1}){0,1}\\d{4}$';
            break;
        case 'sk':
            zipcode_id.attr('maxlength', '6');
            pattern = '^\\d{3}\\s{0,1}\\d{2}$';
            break;
        case 'lt':
            pattern = '^\\d{5}$';
            break;
        case 'mt':
            zipcode_id.attr('maxlength', '8');
            pattern = '^[A-Za-z]{3}\\s{0,1}\\d{4}$';
            break;
        case 'lv':
            zipcode_id.attr('maxlength', '4');
            pattern = '^\\d{4}$';
            break;
        case 'ee':
            pattern = '^\\d{5}$';
            break;
        case 'cy':
            zipcode_id.attr('maxlength', '4');
            pattern = '';
            break;
        case 'jp':
            zipcode_id.attr('maxlength', '8');
            pattern = '^\\d{3}-\\d{4}';
            break;
        default:
            pattern = '';
    }
    zipcode_id.attr('pattern', pattern);
};

window.clear_form = function(formObj) {
    formObj.find('input:text,input[type=email],input:password,textarea,.wcs-dropdown-text,select').each(function() {
        var _self = $(this);
        _self.val('').removeClass('ui-state-valid').removeAttr('style');
        _self.trigger('focusout');
        hide_error(_self);
        hide_error_message(_self);
    });
};

/*function for validating multiple email address*/
 // RB-1253 start
function AllowMultipleEmail() {
    $("#wcs_email_to_friendEmailTest").find("#wcs-forEmail").removeClass("h5-email").attr("pattern","");
}
 // End
function validateEmail(field) {
    var regex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
    return regex.test(field);
}

window.validateMultipleEmails = function(emailcntl, seperator, ev) {
    var value = emailcntl.val();
    if (value !== '') {
        var result = value.split(seperator);
        var resultLength = result.length;
        for (var i = 0; i < resultLength; i++) {
            if ($.trim(result[i]) && !validateEmail($.trim(result[i]))) {
                show_error(emailcntl);
                ev.stopPropagation();
            }
        }
    }
};

/* function for assign value to another field*/
window.Assign_value = function(object1, object2) {
    var value_to_assign = object1.val();
    if (value_to_assign) {
        object2.val(value_to_assign); //.trigger('blur');
    }
};

window.bind_btn_ok = function() {
    $('#btn_ok').off('click').on('click', function() {
        $('#wcs_email_to_friend_confirmation').find('.wcs-close-btn').trigger('click');
    });
};

window.append_emailList = function(emailObj, emailAppenObj) {
    var emails = emailObj.val();
    var emailList = emails.split(',');
    var text = '';
    for (var i in emailList) {
        text += "<li>" + emailList[i] + "</li>";
    }
    emailAppenObj.append(text);
};

function giftCardBalanceValidate() {
    $('#giftCardNumber, #giftCardPin').unbind('keyup.wcsh5 paste.wcsh5').bind('keyup.wcsh5 paste.wcsh5', function() {
        window.setTimeout(function(elem) {
            var $elem = $(elem);
            if($elem.attr('pattern') && elem.value !== '') {
                var regExp = new RegExp($elem.attr('pattern'));
                if(regExp.test($elem.val())) {
                    $elem.removeClass('ui-state-error').addClass('ui-state-valid');
                    $elem.parents('.wcs-row').attr('style', '').find('.wcs-error-message').removeClass('wcs-show');
                }else{
                    $elem.removeClass('ui-state-valid');
                }
            }
        },50,this);
    }).each(function() {
        if(this.value !== '') {
            $(this).blur();
        }
    });
}

var get_error_count = function() {
    return ($(".wcs-error-message:visible").length || $('.rb-fieldrow__helper--error:visible').length);
};

window.zipCodeCAValidation = function() {
    var $zip_code = $('#zip_code');
    var trimmedZip = $zip_code.val().replace(/ /g, '');
    $zip_code.val(trimmedZip.substring(0, 3) + " " + trimmedZip.substring(3, 6));
    return true;
};
